<template>
	<div class="misc-wrapper">
		<b-link class="brand-logo">
			<vuexy-logo />
			<h2 class="brand-text text-primary ml-1">高性能智能建筑系统</h2>
		</b-link>

		<div class="misc-inner p-2 p-sm-3">
			<div class="w-100 text-center">
				<h2 class="mb-1">您未通过身份校验! 🔐</h2>
				<p class="mb-2">您没有权限访问此页面，请返回首页</p>
				<b-button :to="{ path: '/login' }" class="my-2 btn-sm-block" variant="primary">返回首页</b-button>
			</div>
			<b-img :src="imgUrl" alt="Not authorized page" fluid />
		</div>
	</div>
</template>

<script>
	/* eslint-disable global-require */
	import VuexyLogo from "@/@core/layouts/components/Logo.vue";
	import store from "@/store";
	import { getHomeRouteForLoggedInUser } from "@/libs/auth/utils";

	export default {
		components: {
			VuexyLogo,
		},
		data() {
			return {
				downImg: require("@/assets/images/pages/not-authorized.svg"),
			};
		},
		computed: {
			imgUrl() {
				if (store.state.appConfig.layout.skin === "dark") {
					// eslint-disable-next-line vue/no-side-effects-in-computed-properties
					this.downImg = require("@/assets/images/pages/not-authorized-dark.svg");
					return this.downImg;
				}
				return this.downImg;
			},
		},
		methods: {
			loginRoute() {
				const user = JSON.parse(localStorage.getItem("userData"));
				return getHomeRouteForLoggedInUser(user ? user.role : null);
			},
		},
	};
</script>

<style lang="scss">
	@import "src/@core/scss/vue/pages/page-misc.scss";
</style>
